// removed by extract-text-webpack-plugin
module.exports = {"About":"About__-loca-__QiE0X","TextLine":"About__-loca-__35MCr","EmailListLink":"About__-loca-__1di25","Open":"About__-loca-__1JHfd","Close":"About__-loca-__-4b2j","SideDrawerCloseButton":"About__-loca-__3N6aa","BestWishes":"About__-loca-__3Aewf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/HowItWorks/TrdHowItWorks/About/About.css
// module id = 245
// module chunks = 0